<script lang="ts">
    import router from "page";
    import About from "./routes/about.svelte";
    import Auth from "./routes/auth.svelte";        
    import Index from "./routes/index.svelte";
    import NotFound from "./routes/notfound.svelte";
    import { queryString } from "./services/util"
    import Offers from "./routes/offers.svelte";
    import Dashboard from "./routes/dashboard.svelte";
    import Editor from "./routes/editor.svelte"
    import Tailwindcss from './Tailwindcss.svelte';


    let page;
    let params = {};
    let qs = {};

    router("/", () => page = Index)
    router("/about", () => page = About)
    router("/404/:msg", (ctx: {params: {}, querystring: string}, next) => {
        params = ctx.params;
        next();
    }, () => page = NotFound)
    router("/auth", (ctx, next) => {
        qs = queryString(ctx.querystring)
        next();
    }, () => page = Auth)
    router("/login", () => router.redirect("/auth"))
    router("/register", () => router.redirect("/auth"))
    router("/dashboard", () => page = Dashboard)
    router("/offers", (ctx, next) => {
        qs = queryString(ctx.querystring)
        next();
    },() => page = Offers)
    router("/offers/:offerID", (context, next) => {
        params = context.params;
        qs = queryString(context.querystring)
        next();
    }, ()=>{page = Editor}) //change to editor when ready

    router("/*", () => page = NotFound)
    router.start();

</script>
<style global>
@import "../public/global.css";

.ql-bubble .ql-tooltip {
  z-index: 100000;
}
.ql-editor{
    min-height: 68vh;
}
</style>

<svelte:component this={page} {params} {qs} />
